var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('popup',{attrs:{"value":_vm.show,"title":"Вход на сайт"},on:{"input":_vm.close}},[(!_vm.type)?_c('phone-form',{on:{"switch":function($event){_vm.type = !_vm.type}}}):_c('email-form',{on:{"switch":function($event){_vm.type = !_vm.type}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }